export default __webpack_public_path__ + "static/media/icons.c638cd94.png";